module.exports = __webpack_public_path__ + "zm.svg?5b449efa36a7b3401b8a063af72abbe0";